import React from 'react';
import Toolbar from '@material-ui/core/Toolbar';
import {
  List,
  Datagrid,
  Create,
  CreateButton,
  Edit,
  Filter,
  ImageField,
  FileField,
  FileInput,
  SimpleForm,
  TextField,
  TextInput,
  EditButton,
  SelectInput,
  email,
  Show,
  TabbedShowLayout,
  Tab,
  SimpleShowLayout,
  TopToolbar,
  ShowButton,
  DateField,
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import CreatorCourses from './CreatorCourses';

const useStyles = makeStyles({
  tab: {
    maxWidth: '40em',
    '& .MuiInputBase-root': {
      width: '100%',
    },
  },
});

const TextFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Нэр" source="firstName" alwaysOn />
    <TextInput label="Username" source="username" alwaysOn />
  </Filter>
);


const Action = props => {
  const {
    filters,
    showFilter,
    resource,
    displayedFilters,
    filterValues,
    basePath,
  } = props

  return (
    <Toolbar>
      {filters &&
        React.cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button',
        })}
      <CreateButton basePath={basePath} />
    </Toolbar>
  );
};

export const CreatorList = props => (
  <List {...props} filters={<TextFilter/>} actions={<Action props={props} />}>
    <Datagrid rowClick="show">
      <TextField label="ID" source="id" />
      <TextField label="Овог" source="lastName" />
      <TextField label="Нэр" source="firstName" />
      <TextField label="Username" source="username" />
      <TextField label="И-майл" source="email" />
      <TextField label="Мэргэжил" source="profession" />
      <TextField label="Төрөл" source="type" />
      <ImageField label="Зураг" source="avatar" />
      <ShowButton />
      <EditButton />
    </Datagrid>
  </List>
);

const CreatorTitle = ({ record }) => {
  const name = record ? `${record.firstName} ${record.lastName}` : '';
  return <span>Зохиогч: {name}</span>;
};

export const CreatorShow = props => {
  const creatorId = props.id ? String(props.id) : null;
  
  return (
    <Show title={<CreatorTitle />} {...props} actions={<TopToolbar><EditButton /></TopToolbar>}>
      <TabbedShowLayout>
        <Tab label="Ерөнхий мэдээлэл">
          <SimpleShowLayout>
            <TextField source="id" label="ID" />
            <TextField source="firstName" label="Нэр" />
            <TextField source="lastName" label="Овог" />
            <TextField source="username" label="Username" />
            <TextField source="email" label="И-мэйл" />
            <TextField source="profession" label="Мэргэжил" />
            <TextField source="bio" label="Намтар" />
            <TextField source="type" label="Төрөл" />
            <ImageField source="avatar" label="Зураг" />
            <DateField source="createdAt" label="Үүсгэсэн огноо" showTime />
          </SimpleShowLayout>
        </Tab>
        <Tab label="Хичээлүүд">
          {creatorId && <CreatorCourses creatorId={creatorId} />}
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};

export const CreatorEdit = props => {
  const classes = useStyles();
  
  return (
    <Edit title={<CreatorTitle />} {...props}>
      <SimpleForm className={classes.form}>
        <TextInput disabled source="id" />
        <TextInput 
          label="Овог" 
          source="lastName" 
          required 
          style={{ flex: 1 }} 
          helperText="овог ойлгомжгүй тохиолдолд: заавал утга авах учир цэг (.) тавихад болно"
        />
        <TextInput 
          label="Нэр" 
          source="firstName" 
          required 
          style={{ flex: 1 }} 
          helperText="нэр ойлгомжгүй тохиолдолд: creator-н skills.mn дээр харагдах нэрийг оруулна (ж.нь Foody Mongolia)"
        />
        <TextInput label="Username" source="username" />
        <TextInput label="И-майл" source="email" validate={email()} />
        <TextInput label="Мэргэжил" source="profession" />
        <TextInput multiline fullWidth rows={5} label="Намтар" source="bio" />
        <ImageField source="avatar" title="Зураг" />
        <FileInput source="file" label="Зураг" accept="image/*">
          <FileField source="image" title="image" />
        </FileInput>
        <SelectInput
          label="төрөл"
          source="type"
          defaultValue="expert"
          choices={[
            { id: 'master', name: 'master' },
            { id: 'expert', name: 'expert' },
            { id: 'foreign', name: 'foreign' },
          ]}
        />
      </SimpleForm>
    </Edit>
  );
};

const validateCreator = (values) => {
  const errors = {};
  if (!values.lastName) {
    errors.lastName = 'Овог оруулна уу';
  }
  if (!values.firstName) {
    errors.firstName = 'Нэр оруулна уу';
  }
  if (!values.username) {
    errors.username = 'Username оруулна уу';
  }
  if (!values.email) {
    errors.email = 'И-майл оруулна уу';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'И-майл хаяг буруу байна';
  }
  if (!values.profession) {
    errors.profession = 'Мэргэжил оруулна уу';
  }
  if (!values.bio) {
    errors.bio = 'Намтар оруулна уу';
  }
  if (!values.file) {
    errors.file = 'Зураг оруулна уу';
  }
  if (!values.type) {
    errors.type = 'Төрөл сонгоно уу';
  }
  return errors;
};

export const CreatorCreate = props => (
  <Create {...props}>
    <SimpleForm validate={validateCreator}>
      <TextInput 
        label="Овог" 
        source="lastName" 
        required 
        style={{ flex: 1 }} 
        helperText="овог ойлгомжгүй тохиолдолд: заавал утга авах учир цэг (.) тавихад болно"
      />
      <TextInput 
        label="Нэр" 
        source="firstName" 
        required 
        style={{ flex: 1 }} 
        helperText="нэр ойлгомжгүй тохиолдолд: creator-н skills.mn дээр харагдах нэрийг оруулна (ж.нь Foody Mongolia)"
      />
      <TextInput label="Username" source="username" required/>
      <TextInput label="И-майл" source="email" validate={email()} required/>
      <TextInput label="Мэргэжил" source="profession" required/>
      <TextInput multiline fullWidth rows={5} label="Намтар" source="bio" required/>
      <FileInput source="file" label="Зураг" accept="image/*" required>
        <FileField source="image" title="image"/>
      </FileInput>
      <SelectInput
        label="төрөл"
        source="type"
        defaultValue="expert"
        choices={[
          { id: 'master', name: 'master' },
          { id: 'expert', name: 'expert' },
          { id: 'foreign', name: 'foreign' },
        ]}
        required
      />
    </SimpleForm>
  </Create>
);

